import { useState, useEffect } from 'react';
import bus from '../../utils/bus.js';
import '../../styles/common/message.css';

function Message() {
    const [visible, setVisible] = useState(false);
    const [message, setMessage] = useState("");
    const [type, setType] = useState("");

    useEffect(() => {

        bus.addListener("flash", ({ message, type }) => {
            setVisible(true);
            setMessage(message);
            setType(type);

            setTimeout(() => {
                setVisible(false);
            }, 5000);
        });

    }, []);


    return (
        visible && (
            <div className={`message ${type}`}>
                {message}
            </div>
        )
    );
}

export default Message;